"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISOLATE_X_PADDING = exports.ISOLATE_MAX_WIDTH = void 0;
exports.ISOLATE_MAX_WIDTH = 440;
exports.ISOLATE_X_PADDING = 14;
//# sourceMappingURL=constants.js.map